import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UsersRound } from "lucide-react";
import { listStaff, removeStaff, resendStaff } from "../../api/platformStaff";
import { useAuth } from "../../context/AuthContext";
import { NeuCard } from "../../components/neu/Neu";
import { StaffInvite } from "./StaffInvite";
import { StaffRow } from "./StaffRow";
import { StaffPermsRow } from "./StaffPermsRow";

export const StaffPanel = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [members, setMembers] = useState([]);

  const load = async () => setMembers(await listStaff());
  useEffect(() => {
    load();
  }, []);

  const resend = async (id) => {
    await resendStaff(id);
    load();
  };
  const remove = async (id) => {
    await removeStaff(id);
    load();
  };

  return (
    <NeuCard data-testid="staff-panel">
      <div className="flex items-center gap-3">
        <UsersRound className="h-5 w-5 text-primary" />
        <div>
          <h2 className="text-lg font-black">{t("staff.title")}</h2>
          <p className="text-xs text-muted-foreground">{t("staff.subtitle")}</p>
        </div>
      </div>
      <StaffInvite onDone={load} />
      <div className="mt-4 grid gap-3" data-testid="staff-list">
        {members.map((m) => (
          <div key={m.id}>
            <StaffRow member={m} onResend={resend} onRemove={remove} isSelf={m.id === (user?.id || user?._id)} />
            {m.role === "platform_admin" ? <StaffPermsRow member={m} reload={load} /> : null}
          </div>
        ))}
        {!members.length ? <p className="text-sm text-muted-foreground">{t("staff.empty")}</p> : null}
      </div>
    </NeuCard>
  );
};
